export default "__VITE_ASSET__DEe7DK4$__"